module.exports = __webpack_public_path__ + "8cd3b7a75bc312c038a3700fdfe5a3ef.pdf";